import { render, staticRenderFns } from "./OrderDetailDateForm.vue?vue&type=template&id=6fde6de6&"
import script from "./OrderDetailDateForm.vue?vue&type=script&lang=js&"
export * from "./OrderDetailDateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports